import { useContext, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import UserContext from "../UserContext";
import SEO from "../Components/SEO";

export default function GamesBoard() {
  const { mode } = useContext(UserContext);
  // setting the theme
  const [dark, setDark] = useState(false);
  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  return (
    <>
      <SEO title={`TA-GameBoard`} description="Twika Games Hub"></SEO>
      <div
        className={
          dark ? "sm:px-5 lg:px-60 mb-10 darkmode" : "sm:px-5 lg:px-60 mb-10"
        }
      >
        <div className="w-full">
          <div className="lg:px-20 lg:flex w-full gap-10">
            <div className="w-full">
              <div className="w-full h-full flex items-center  p-4 lg:p-10">
                <div className="w-full">
                  <div className="w-full mb-5">
                    <h1 className="text-sm font-bold text-center">
                      TA-Gameboard 🔥
                    </h1>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="mobo-active-icon mx-auto"
                      viewBox="0 0 24 24"
                      width="100"
                      height="100"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M17 4a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6H7a6 6 0 0 1-6-6v-4a6 6 0 0 1 6-6h10zm0 2H7a4 4 0 0 0-3.995 3.8L3 10v4a4 4 0 0 0 3.8 3.995L7 18h10a4 4 0 0 0 3.995-3.8L21 14v-4a4 4 0 0 0-3.8-3.995L17 6zm-7 3v2h2v2H9.999L10 15H8l-.001-2H6v-2h2V9h2zm8 4v2h-2v-2h2zm-2-4v2h-2V9h2z" />
                    </svg>
                  </div>

                  {/* games list */}

                  {/* game 1 */}
                  <div
                    className={
                      "border border-fire rounded p-3 w-full my-3 grid grid-cols-2 items-center " +
                      (dark && " divbg-in-darkmode ")
                    }
                  >
                    🎮 Guessing game
                    <NavLink to="/games/guess-it">
                      <span className="bg-fire text-white py-2 px-3 rounded-full text-xs float-right hover:opacity-50">
                        Play
                      </span>
                    </NavLink>
                  </div>

                  {/* game 2 */}
                  <div
                    className={
                      "border border-fire rounded p-3 w-full my-3 grid grid-cols-2 items-center " +
                      (dark && " divbg-in-darkmode ")
                    }
                  >
                    <div>
                      🤪 Word Puzzle
                      <span className="ml-2 text-xs  font-mono italic hover:text-white hommy--btn rounded-full px-2 py-1 mr-3 hover:opacity-80 no-underline">
                        Latest
                      </span>
                    </div>
                    <NavLink to="/games/word-puzzle">
                      <span className="bg-fire text-white py-2 px-3 rounded-full text-xs float-right hover:opacity-50">
                        Play
                      </span>
                    </NavLink>
                  </div>

                  {/* upcoming games  */}
                  <h1 className="text-sm font-bold mt-8">Upcoming Games</h1>
                  <div
                    className={
                      "border border-fire rounded p-3 w-full my-3 grid grid-cols-2 items-center hidden " +
                      (dark && " divbg-in-darkmode ")
                    }
                  >
                    👊 Fingers Battle
                    <NavLink
                      to={
                        process.env.NODE_ENV === "development"
                          ? "/games/fingers-battle"
                          : "#"
                      }
                    >
                      <span className="bg-fire text-white py-2 px-3 rounded-full text-xs float-right hover:opacity-50">
                        Coming tomorrow
                      </span>
                    </NavLink>
                  </div>

                  <div
                    className={
                      "border border-fire rounded p-3 w-full my-3 grid grid-cols-2 items-center " +
                      (dark && " divbg-in-darkmode ")
                    }
                  >
                    👧🏻🔺🔴⭐️☂️🔪 Squid Game
                    <NavLink
                      to={
                        process.env.NODE_ENV === "development"
                          ? "/games/fingers-battle"
                          : "#"
                      }
                    >
                      <span className="bg-fire text-white py-2 px-3 rounded-full text-xs float-right hover:opacity-50">
                        Coming next week
                      </span>
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
